<div class="notification" [class.notification--read]="notification().is_read">
  <div class="notification__icon" [class]="iconClass()">
    <span class="material-symbols-rounded">{{ config().icon }}</span>
  </div>

  <div class="notification__content">
    <span class="notification__text textos-body-medium">
      {{ notificationText() }}
      @if (showProgress()) {
        @if (progressText(); as progress) {
          : {{ progress }}.
        }
      }
    </span>

    @if (showProgress()) {
      <div class="notification__progress">
        <mat-progress-bar
          mode="determinate"
          [value]="percentage()"></mat-progress-bar>
        <span class="notification__percentage"
          >{{ percentage() | number: '1.0-0' }}%</span
        >
      </div>
    }

    @if (summaryLines().length > 0) {
      <div class="notification__summary">
        @for (line of summaryLines(); track line) {
          <span class="notification__text textos-body-medium">{{ line }}</span>
        }
      </div>
    }

    @if (showAction()) {
      <div class="notification__actions">
        <button
          class="notification__download-btn"
          type="button"
          (click)="onAction()">
          @if (action()?.icon; as actionIcon) {
            <mat-icon [fontIcon]="actionIcon"></mat-icon>
          }
          {{ action()?.label }}
        </button>
      </div>
    }

    <div class="notification__meta">
      @if (notification().user) {
        <span>Por: {{ notification().user?.name }}</span>
        <span class="metadata-separator"> |</span>
        <span>{{ notificationDate() | date: 'dd/MM/yyyy HH:mm' }}</span>
      }
    </div>
  </div>

  @if (showCheckbox()) {
    <mat-checkbox
      class="selection-checkbox"
      [checked]="isSelected()"
      (change)="onSelectionChange()"
      color="primary"
      aria-label="Seleccionar notificación"></mat-checkbox>
  }
</div>
